import XLSX from 'xlsx';

import { CustomerList } from './CustomerExcel';
// import { SQCustomerExcel } from './SQCustomerExcel';
// import { DATA } from './sqDATA';

export function CustomerListExcel(data) {
    CustomerList(XLSX, data)
}

// export function SQCUSTExcel() {
//     SQCustomerExcel(XLSX, DATA)
// }